import { useTranslation } from 'react-i18next';
import classes from './Steps.module.scss';
import image from '../../../assets/img/MechanicalWorks/steps.avif';

const cards = [
    {
        subtitle: 'mechanical.steps.card_01.subtitle',
        desc: 'mechanical.steps.card_01.desc',
    },
    {
        subtitle: 'mechanical.steps.card_02.subtitle',
        desc: 'mechanical.steps.card_02.desc',
    },
    {
        subtitle: 'mechanical.steps.card_03.subtitle',
        desc: 'mechanical.steps.card_03.desc',
    },
    {
        subtitle: 'mechanical.steps.card_04.subtitle',
        desc: 'mechanical.steps.card_04.desc',
    },
    {
        subtitle: 'mechanical.steps.card_05.subtitle',
        desc: 'mechanical.steps.card_05.desc',
    },
];

const Steps = () => {
    const { t } = useTranslation();
    return (
        <section className="mt container">
            <div className={classes.wrap}>
                <div className={classes.body}>
                    <h2 className={`${classes.title} font-48`}>
                        {t('mechanical.steps.title')}
                    </h2>
                    <div className={classes.cards}>
                        {cards.map((card, index) =>
                            <div key={index} className={classes.card}>
                                <div className={classes.num}>
                                    {index + 1}
                                </div>
                                <div className={`${classes.content} font-16`}>
                                    <h4 className={classes.subtitle}>
                                        {t(card.subtitle)}
                                    </h4>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <img className={classes.image} src={image} alt='' />
            </div>
        </section>
    );
};

export default Steps;
